import script from "./HeaderUzafoundation.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderUzafoundation.vue?vue&type=script&setup=true&lang=js"

import "./HeaderUzafoundation.vue?vue&type=style&index=0&id=b12f4018&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b12f4018"]])

export default __exports__